export enum EntityType {
  Aircraft,
  MapFeature,
  Runway,
  Fix,
  Star,
}
